import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Fragment } from 'react'

import { IProps } from './IProps'
import {
  FloatingButton,
  NavContainer,
  NavLink,
  NavSlot,
  NavSlotCurve,
} from './style'

export const BottomNavigation = ({ links, addButton }: IProps) => {
  const buttonAppendPoint: number = Math.floor(links.length / 2)
  const currentPath = window.location.pathname
  const mappedLinks = links.map((data, i) => {
    const linkAttributes: {
      start: boolean
      end: boolean
      activeLocation: boolean
    } = {
      start: i === 0,
      end: i + 1 === links.length,
      activeLocation: data.path === currentPath,
    }

    const CurrentLink = () => {
      return (
        <NavSlot
          key={`navSlot${i}`}
          navStart={linkAttributes.start}
          navEnd={linkAttributes.end}>
          <NavLink
            to={data.path}
            color={linkAttributes.activeLocation ? '#005cdb' : null}>
            <FontAwesomeIcon icon={data.icon} />
          </NavLink>
        </NavSlot>
      )
    }

    if (i === buttonAppendPoint && addButton) {
      return (
        <Fragment key={`botNavAddBtn${i}`}>
          <NavSlotCurve navStart={false} navEnd={false}>
            <FloatingButton to={addButton}>
              <FontAwesomeIcon icon={'plus'} />
            </FloatingButton>
          </NavSlotCurve>
          <CurrentLink />
        </Fragment>
      )
    }
    return <CurrentLink key={`currentLink${i}`} />
  })

  return <NavContainer>{mappedLinks}</NavContainer>
}
